/*=========================================================================================
  File Name: moduleEcommerceGetters.js
  Description: Ecommerce Module Getters
  ----------------------------------------------------------------------------------------
  Item Name: BCC Pubs
  Author: SweetAs
  Author URL: http://sweetas.xyz
==========================================================================================*/

export default {
  isInCart: state => itemId => {
    return state.cartItems.some(item => item.sku === itemId)
  },
  isInWishList: state => itemId => {
    return state.wishList.some(item => item.sku === itemId)
  },
  getCartItem: state => itemId => {
    const result = state.cartItems.filter(item => item.sku === itemId)
    return result.length ? result.pop() : []
  }
}
